
// Button Shadow Update
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".shaddow_btn_custom").forEach((button) => {
    button.addEventListener("click", function () {
      // Remove border
      this.style.setProperty("box-shadow", "-1px 1px 0 black", "important");
      this.style.setProperty("transform", "translateY(1.5px)", "important");

      // Reset border after 1 second
      setTimeout(() => {
        this.style.removeProperty("box-shadow");
        this.style.removeProperty("transform");
      }, 300); // 1000ms = 1 second
    });
  });
});

// Universal mega menu height set 0 when hide on scroll enabled

document.addEventListener("DOMContentLoaded", () => {
  const root = document.documentElement;
  const universalMenu = document.querySelector(".universal-mega-menu-section");

  function isVisible(el) {
    if (!el) return false;
    const style = getComputedStyle(el);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      el.offsetHeight > 0
    );
  }

  function updateUniversalMegaMenuHeight() {
    const root = document.documentElement;
    const universalMenu = document.querySelector(
      ".universal-mega-menu-section"
    );

    if (!universalMenu) return;

    const isDesktop = window.innerWidth >= 1070;
    const isVisible =
      universalMenu.offsetHeight > 0 &&
      getComputedStyle(universalMenu).display !== "none";
    const isHiddenByScroll = universalMenu.classList.contains("sticky-hide");

    // On mobile: always set to 0px
    if (!isDesktop) {
      root.style.setProperty("--universal-mega-menu-section", "0px");
      return;
    }

    // On desktop: dynamic value based on scroll
    const height =
      isVisible && !isHiddenByScroll
        ? `${universalMenu.offsetHeight}px`
        : "0px";
    root.style.setProperty("--universal-mega-menu-section", height);
  }

  // Attach scroll/resize events only on desktop
  function attachDesktopMenuListeners() {
    if (window.innerWidth >= 1070) {
      window.addEventListener("scroll", updateUniversalMegaMenuHeight);
      window.addEventListener("resize", updateUniversalMegaMenuHeight);
    }
  }

  // Initial run for both mobile & desktop
  updateUniversalMegaMenuHeight();

  // Attach events only for desktop
  attachDesktopMenuListeners();

  // Initial check
  updateUniversalMegaMenuHeight();

});
